import { render, staticRenderFns } from "./DrivewealthDisclosures.vue?vue&type=template&id=35479a02&scoped=true"
import script from "./DrivewealthDisclosures.vue?vue&type=script&lang=ts"
export * from "./DrivewealthDisclosures.vue?vue&type=script&lang=ts"
import style0 from "./DrivewealthDisclosures.vue?vue&type=style&index=0&id=35479a02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35479a02",
  null
  
)

export default component.exports